import { employeeInitials } from "./vacationCalendarUtils";

const WEEKDAY_LABELS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];

const ABSENCE_TYPES = [
  { value: "vacation", label: "Vacaciones" },
  { value: "personal_leave", label: "Permiso personal" },
  { value: "sick_leave", label: "Baja / enfermedad" },
  { value: "other_absence", label: "Otra ausencia" },
  { value: "remote_day", label: "Teletrabajo" },
];

const TYPE_COLORS = {
  vacation: "#2e7d32",
  personal_leave: "#ed6c02",
  sick_leave: "#d32f2f",
  other_absence: "#7b1fa2",
  remote_day: "#0288d1",
};

const EMPLOYEE_PALETTE = [
  "#43a047",
  "#fb8c00",
  "#ec407a",
  "#29b6f6",
  "#8e24aa",
  "#5c6bc0",
  "#00897b",
  "#f4511e",
];

function pad2(n) {
  return String(n).padStart(2, "0");
}

function expandEntryDates(startDate, endDate) {
  const dates = [];
  const d = new Date(`${startDate}T12:00:00`);
  const end = new Date(`${endDate}T12:00:00`);
  while (d <= end) {
    const y = d.getFullYear();
    const m = pad2(d.getMonth() + 1);
    const day = pad2(d.getDate());
    dates.push(`${y}-${m}-${day}`);
    d.setDate(d.getDate() + 1);
  }
  return dates;
}

function buildWeekdayWeeks(year, month) {
  const lastDay = new Date(year, month, 0).getDate();
  const weeks = [];
  let week = [null, null, null, null, null];

  for (let day = 1; day <= lastDay; day += 1) {
    const date = new Date(year, month - 1, day);
    const dow = date.getDay();
    if (dow === 0 || dow === 6) continue;

    const col = dow - 1;
    if (col === 0 && week.some(Boolean)) {
      weeks.push(week);
      week = [null, null, null, null, null];
    }

    week[col] = {
      day,
      dateStr: `${year}-${pad2(month)}-${pad2(day)}`,
    };
  }

  if (week.some(Boolean)) weeks.push(week);
  return weeks;
}

function employeeColor(userId) {
  return EMPLOYEE_PALETTE[Math.abs(Number(userId)) % EMPLOYEE_PALETTE.length];
}

function buildMonthAbsenceMap(entries, filters, year, month) {
  const { types, showApproved, showPending, search } = filters;
  const q = search.trim().toLowerCase();
  const monthPrefix = `${year}-${pad2(month)}`;
  const byDate = {};

  entries.forEach((entry) => {
    if (!types.has(entry.requestType)) return;
    if (entry.status === "approved" && !showApproved) return;
    if (entry.status === "pending" && !showPending) return;
    if (entry.status !== "approved" && entry.status !== "pending") return;
    if (q && !String(entry.username || "").toLowerCase().includes(q)) return;

    const dates = expandEntryDates(entry.startDate, entry.endDate);
    dates.forEach((dateStr) => {
      if (!dateStr.startsWith(monthPrefix)) return;
      const dow = new Date(`${dateStr}T12:00:00`).getDay();
      if (dow === 0 || dow === 6) return;
      if (!byDate[dateStr]) byDate[dateStr] = [];
      byDate[dateStr].push({
        id: `${entry.id}-${dateStr}`,
        userId: entry.userId,
        username: entry.username,
        initials: employeeInitials(entry.username),
        requestType: entry.requestType,
        status: entry.status,
        color: employeeColor(entry.userId),
      });
    });
  });

  Object.keys(byDate).forEach((k) => {
    byDate[k].sort((a, b) => a.username.localeCompare(b.username, "es"));
  });

  return byDate;
}

function shiftMonth(year, month, delta) {
  const d = new Date(year, month - 1 + delta, 1);
  return { year: d.getFullYear(), month: d.getMonth() + 1 };
}

function formatMonthHeading(year, month) {
  const d = new Date(year, month - 1, 1);
  return d.toLocaleDateString("es-ES", { month: "long", year: "numeric" });
}

function countPending(entries) {
  return entries.filter((e) => e.status === "pending").length;
}

export {
  WEEKDAY_LABELS,
  ABSENCE_TYPES,
  TYPE_COLORS,
  buildWeekdayWeeks,
  buildMonthAbsenceMap,
  shiftMonth,
  formatMonthHeading,
  countPending,
};
